import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import INFO from "../../data/user";

import "./styles/educations.css";

const Educations = () => {
	return (
		<div className="educations">
			{INFO.educations.map((education, index) => (	
				<div className={`education-card`} key={index}>
					<div className="education-card-header">
						<div className="education-card-icon">
							<FontAwesomeIcon icon={faGraduationCap} />
						</div>
					</div>
					<div className="education-body">
						<div className="education-header" >
							<img
								src={education.logo}
								alt={education.name}
								className="education-image"
							/>
							<a className="education-title education-card-link" href={education.link} target="_blank" rel="noreferrer">{education.name}</a>
							
						</div>
						<div className="education-subtitle">
							{education.major}
						</div>
						<div className="education-duration"><span>{education.time}</span><span>{education.location}</span></div>
					</div>
				</div>
			))}
		</div>
	);
};

export default Educations;
